import { Injectable } from '@angular/core';


@Injectable({ providedIn: 'root' })

export class UsefulService {
    constructor() { }
    orderByFilters(listDispatchs, filter): any[] {
        const arrayFilters = Array.isArray(filter) ? filter.join().split(' ') : filter.split(' ');
        arrayFilters.forEach(element => {
            listDispatchs.sort(function (dispatch) {
                if (dispatch.dispatchId === element) {
                    return -1;
                }
                if (dispatch.dispatchId !== element) {
                    return 1;
                }
                return 0;
            });
        });
        return listDispatchs.reverse();
    }
}
